import {alias, createModelSchema, custom, deserialize, serialize, SKIP} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {CurrencyKindModel} from "@/modules/redactor/models/currency/CurrencyKindModel";
import {Schema} from "@/common/Schema";

export class GuardMoneyRule extends Cloneable {

    static schema() {
        return custom(
            (v) => {
                return v && !v.empty() ? serialize(GuardMoneyRule, v) : SKIP;
            },
            (v) => {
                return deserialize(GuardMoneyRule, v);
            }
        );
    }

    constructor() {
        super();

        this._kind = null;
        this._lower = 0;
        this._upper = 0;
        this._notEnough = false;
    }

    get kind() {
        return this._kind;
    }

    set kind(value) {
        this._kind = value;
    }

    get lower() {
        return this._lower;
    }

    set lower(value) {
        this._lower = value;
    }

    get upper() {
        return this._upper;
    }

    set upper(value) {
        this._upper = value;
    }

    get notEnough() {
        return this._notEnough;
    }

    set notEnough(value) {
        this._notEnough = value;
    }

    valid() {

        if (!CurrencyKindModel.is(this.kind)) {
            return false;
        }

        if (!Number.isInteger(this.lower) || this.lower < 0) {
            return false;
        }

        if (!Number.isInteger(this.upper) || this.upper < 0) {
            return false;
        }

        if (this.lower > this.upper && this.upper > 0) {
            return false;
        }

        return true;
    }

    empty() {
        return !CurrencyKindModel.is(this.kind);
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new GuardMoneyRule());
        } else if (target instanceof GuardMoneyRule) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(GuardMoneyRule, {
    _kind: alias("kind", CurrencyKindModel.schema()),
    _lower: alias("lower", Schema.primitive()),
    _upper: alias("upper", Schema.primitive()),
    _notEnough: alias("not_enough", Schema.primitive()),
});